import { hasYesOrNo } from 'models/validate';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { REQUIRED } from 'constants/errors';
import { setToStartOfMonth } from 'helpers/date';
import { isPVQForm } from 'helpers/form';
import { ForeignTravelItemModel } from '../types';

const daysOptions = ['1-5', '6-10', '11-20', '21-30', 'More than 30', 'Many short trips'];
const daysOptionsPvq = ['0-1', '1-7', '8-14', '15-30', 'Over 30', 'Many short trips', 'Other'];

const purposeOptions = [
  'Business',
  'Volunteer',
  'Education',
  'Tourism',
  'Conference',
  'Family',
  'Other',
];

export const foreignTravelItemValidator: ValidateJSModel<ForeignTravelItemModel> = {
  Country: (value, attributes) => {
    if (attributes?.CountryFocused) {
      return {};
    }

    return { hasValue: true, country: { excludeUnitedStates: true } };
  },

  Dates: (value, attributes, attributeName, options = {}) => {
    const { applicantBirthdate } = options;

    return {
      presence: true,
      daterange: { earliest: setToStartOfMonth(applicantBirthdate), latest: DEFAULT_LATEST },
    };
  },

  Days: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        presence: true, hasValue: { validator: { inclusion: daysOptionsPvq } }
      };
    }
    else {
      return {
        presence: true, hasValue: { validator: { inclusion: daysOptions } }
      };
    }
  },


  Purpose: {
    presence: true,
    array: {
      length: { minimum: 1, message: REQUIRED },
      validator: { inclusion: purposeOptions },
    },
  },

  PurposeExplanation: (value, attributes, attributeName, options) => (
    isPVQForm(options?.formType) && attributes?.Purpose?.values?.includes('Other')
      ? { presence: true, hasValue: true }
      : {}
  ),

  Questioned: { presence: true, hasValue: { validator: hasYesOrNo } },

  QuestionedExplanation: (value, attributes) => {
    const { Questioned } = attributes;
    if (Questioned && Questioned.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  Encounter: { presence: true, hasValue: { validator: hasYesOrNo } },

  EncounterExplanation: (value, attributes) => {
    const { Encounter } = attributes;
    if (Encounter && Encounter.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  Contacted: { presence: true, hasValue: { validator: hasYesOrNo } },

  ContactedExplanation: (value, attributes) => {
    const { Contacted } = attributes;
    if (Contacted && Contacted.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  Counter: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }

    if (options?.requireForeignCounterIntelligence) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },

  CounterExplanation: (value, attributes, attributeName, options) => {
    const { Counter } = attributes;

    if (isPVQForm(options?.formType) && Counter && Counter.value === 'Yes') {
      return { presence: true, hasValue: true };
    }

    if (options?.requireForeignCounterIntelligence && Counter && Counter.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  Interest: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }

    if (options?.requireForeignExcessiveKnowledge) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },

  InterestExplanation: (value, attributes, attributeName, options) => {
    const { Interest } = attributes;

    if (isPVQForm(options?.formType) && Interest && Interest.value === 'Yes') {
      return { presence: true, hasValue: true };
    }

    if (options?.requireForeignExcessiveKnowledge && Interest && Interest.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  Sensitive: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }

    if (options?.requireForeignSensitiveInformation) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },

  SensitiveExplanation: (value, attributes, attributeName, options) => {
    const { Sensitive } = attributes;

    if (isPVQForm(options?.formType) && Sensitive && Sensitive.value === 'Yes') {
      return { presence: true, hasValue: true };
    }

    if (options?.requireForeignSensitiveInformation && Sensitive && Sensitive.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  Threatened: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }

    if (options?.requireForeignThreatened) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },

  ThreatenedExplanation: (value, attributes, attributeName, options) => {
    const { Threatened } = attributes;

    if (isPVQForm(options?.formType) && Threatened && Threatened.value === 'Yes') {
      return { presence: true, hasValue: true };
    }

    if (options?.requireForeignThreatened && Threatened && Threatened.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
};
